module.exports = __webpack_public_path__ + "66815af4b647088d72e4897a525e468c.svg";